// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const HoroscopeDatePicker = registerClientReference(
    function() { throw new Error("Attempted to call HoroscopeDatePicker() from the server but HoroscopeDatePicker is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/tuvi/horoscope-date-picker.tsx",
    "HoroscopeDatePicker",
);
